import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import {
  Search,
  Bell,
  User,
  FileText,
  Calendar,
  Users,
  Settings,
  DollarSign,
} from "lucide-react";
import jwtDecode from "jwt-decode";
import "../Component/Dashboard.css";

export default function UserManagerLayout() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const email =
          decoded[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
          ];
        setUserName(email || "Unknown User");
      } catch {
        setUserName("Unknown User");
      }
    }
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        localStorage.clear();
        navigate("/");
        window.location.reload();
      } else {
        console.error("Logout failed");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <div className="page">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>AdvocatePro</h2>
          <p>Management Dashboard</p>
        </div>
        <nav className="sidebar-nav">
          <Link to="/usermanager">
            <NavItem icon={<FileText size={16} />} label="Dashboard" active />
          </Link>
          <Link to="/usermanager/cases">         
            <NavItem icon={<Users size={16} />} label="Cases" />
          </Link>
          <Link to="/usermanager/party">
            <NavItem icon={<User size={16} />} label="Clients" />
          </Link>
          <NavItem icon={<Calendar size={16} />} label="Calendar" />
          <NavItem icon={<DollarSign size={16} />} label="Payments" />
          <NavItem icon={<Settings size={16} />} label="Settings" />
        </nav>
        <div className="sidebar-footer">
          <button className="btn" onClick={() => navigate("/usermanager/newcase")}>
            New Case
          </button>
        </div>        
      </aside>

      <main className="content">
        {/* Header */}
        <header className="header">
          <div className="search-area">
            <input type="text" placeholder="Search cases, clients, courts..." />
            <span className="search-icon">
              <Search size={16} />
            </span>
          </div>
          <div className="header-right">
            <button className="icon-btn">
              <Bell size={18} />
            </button>

            {/* Avatar dropdown */}
            <div className="user-menu">
              <div
                className="avatar"
                onClick={() => setMenuOpen((prev) => !prev)}
              >
                {getAvatarLetter(userName)}
              </div>
              {menuOpen && (
                <div className="dropdown">
                  <div className="dropdown-item">Profile</div>
                  <div className="dropdown-item" onClick={handleLogout}>
                    Logout
                  </div>
                </div>
              )}
            </div>
            <div className="role">{userName}</div>
          </div>
        </header>

        {/* Child Pages Load Here */}
        <Outlet />

        <footer className="footer">
          © {new Date().getFullYear()} AdvocatePro — Built for efficient case
          management
        </footer>
      </main>
    </div>
  );
}

function NavItem({ icon, label, active }) {
  return (
    <div className={`nav-item ${active ? "active" : ""}`}>
      {icon}
      <span>{label}</span>
    </div>
  );
}

function getAvatarLetter(userName) {
  if (!userName) return "A";
  const cleanName = userName.replace(/[^a-zA-Z ]/g, "").trim();
  const firstWord = cleanName.split(" ")[0];
  return firstWord.charAt(0).toUpperCase();
}
